$(function () {
  if (!customElements.get('choose-products')) {
    customElements.define(
      'choose-products',
      class chooseProducts extends HTMLElement {
        constructor() {
          super();
          this.$variantContainer = null;
          this.$currentQuantity = 1;

          this.$current_inventory_quantity = 0;
        }

        connectedCallback() {
          this.$priceContainer = this.querySelector('.price-container');
          this.$variantContainer = this.querySelector('.variant-container');
          this.$productsPrchase = document.querySelector('products-purchase .products-purchase');
          this.$productStickyFormPrice = document.querySelector('product-sticky-form-price .product-sticky-form-price');

          this.VariantFunction();
        }
        VariantFunction() {
          let progressList = this.$variantContainer.querySelectorAll('.progress');
          progressList.forEach((res) => {
            this.progressFuncion(res);
          });
          this.skuSwatch();
          this.initResult();
        }
        initResult() {
          const activeItem = this.$variantContainer.querySelector('.active-sku');

          if (activeItem) {
            this.$current_inventory_quantity = activeItem.getAttribute('data-inventory_quantity');
          }

          const quantityContainer = this.querySelector('.quantity-container');
          const quantityInput = quantityContainer.querySelector('input[type="text"]'); // 查找输入框
          console.log('quantityInput', quantityInput);
          if (quantityInput) {
            quantityInput.max = this.$current_inventory_quantity; // 设置最大值
          }
          // 监听 input 事件
          quantityInput.addEventListener('input', (event) => {
            console.log(event.target.value);
            if (event.target.value >= 1) {
              this.$currentQuantity = event.target.value;
              const value = new CustomEvent('quantityChange', { detail: event.target.value });
              window.dispatchEvent(value); // 触发事件
            }
          });
          // 监听 `quantityChange` 事件
          window.addEventListener('quantityChange', (event) => {
            this.$currentQuantity = event.detail;
            const value = new CustomEvent('updateResult', { detail: event.detail });
            window.dispatchEvent(value); // 触发事件
          });
        }

        skuSwatch() {
          const productFormRadios = this.$variantContainer.querySelectorAll('.product-form__radio');
          let skuList = this.$variantContainer.querySelectorAll('.sku');
          skuList.forEach((res) => {
            customEventListener(res, 'click', () => {
              const current_url = res.getAttribute('data-url');
              const current_id = res.getAttribute('data-id');
              const current_product_id = res.getAttribute('data-product_id');
              const current_inventory_quantity = res.getAttribute('data-inventory_quantity');
              const current_position = res.getAttribute('data-position');
              const current_section = res.getAttribute('data-section');
              let current_price = res.getAttribute('data-price');
              current_price = current_price.replace(/[^0-9.-]+/g, '');

              res.querySelector('.product-form__radio').checked = true;
              productFormRadios.forEach((radio) => {
                radio.checked = false; // 取消选中状态
              });
              if (current_inventory_quantity > 0) {
                if (this.querySelector('.quantity-container')) {
                  const quantityContainer = this.querySelector('.quantity-container');
                  const quantityInput = quantityContainer.querySelector('input[type="text"]'); // 查找输入框
                  if (quantityInput) {
                    // 更新最大值
                    quantityInput.max = current_inventory_quantity;

                    // 检查当前值是否超过新的最大值
                    if (parseInt(quantityInput.value, 10) > current_inventory_quantity) {
                      quantityInput.value = current_inventory_quantity; // 将值限制为新最大值
                      this.$currentQuantity = quantityInput.value;
                    }
                  }
                }
                console.log('resres', res);
                this.renderProductInfo(
                  current_url,
                  current_id,
                  current_inventory_quantity,
                  current_section,
                  current_product_id,
                  current_position,
                  current_price
                );
              }
            });
          });
        }
        renderProductInfo(
          current_url,
          current_id,
          current_inventory_quantity,
          current_section,
          current_product_id,
          current_position,
          current_price
        ) {
          // 当前变体有库存
          if (current_inventory_quantity > 0) {
            // 判断是否切换变体ID

            fetch(`${current_url}?variant=${current_id}&section_id=${current_section}`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');

                this.updateURL(current_url, current_id);

                this.handleUpdateProductInfo(html, current_product_id, current_position, current_price, current_id);
              });
          }
        }
        handleUpdateProductInfo(html, current_product_id, current_position, current_price, current_id) {
          const chooseProducts = html.querySelector('choose-products .variant-container');
          const productsPurchase = html.querySelector('products-purchase .products-purchase');
          const productStickyFormPrice = html.querySelector('product-sticky-form-price .product-sticky-form-price');

          // 将轮播位置值传递到父组件中
          const event = new CustomEvent('current_positionChange', {
            detail: { current_position: current_position - 1 },
          });

          window.dispatchEvent(event);

          // 保存当前数量
          const currentQuantity = this.$currentQuantity;

          // 更新DOM
          this.$variantContainer.innerHTML = chooseProducts.innerHTML;
          this.$productsPrchase.innerHTML = productsPurchase.innerHTML;
          this.$productStickyFormPrice.innerHTML = productStickyFormPrice.innerHTML;

          // 获取 custom element 实例并调用方法
          const stickyFormBottom = document.querySelector('product-sticky-form-bottom');
          if (stickyFormBottom) {
            stickyFormBottom.nowQuantityClick();
          }

          document.querySelector('products-purchase .products-purchase').setAttribute('data-variant-id', current_id);
          document
            .querySelector('product-sticky-form-bottom .product-sticky-form-bottom')
            .setAttribute('data-variant-id', current_id);

          console.log('currentQuantity123', currentQuantity);
          const quantityContainer = this.querySelector('.quantity-container');
          const quantityInput = quantityContainer.querySelector('input[type="text"]');
          // 重置数量为1
          this.$currentQuantity = 1;
          quantityInput.value = 1;
          // 创建新的事件，detail值为1
          const value = new CustomEvent('quantityChange', { detail: 1 });

          window.dispatchEvent(value);
          // 找到所有推荐产品的复选框并更新状态
          const recommendProducts = document.querySelectorAll('.product-recommendations .products-select-menu');
          window.selectedProducts = [];
          recommendProducts.forEach((menu) => {
            const borderElement = menu.querySelector('.border-primary');

            // 如果存在 .border-primary 元素，才移除该类
            if (borderElement) {
              borderElement.classList.remove('border-primary');
            }

            // 取消选中复选框
            const checkbox = menu.querySelector('input[type="checkbox"]');
            if (checkbox) {
              checkbox.checked = false;
            }

            // 触发价格更新事件
            menu.updateTotalPrices(false);
          });

          // 先更新价格容器的原始价格
          $('.product-sticky-form-price').each((index, res) => {
            const priceElement = res.querySelector('.price');
            const comparePriceElement = res.querySelector('.compare_at_price');

            // 从新的HTML中获取原始价格
            const originalPrice = productStickyFormPrice.querySelector('.current_price').textContent;
            const originalComparePrice = productStickyFormPrice.querySelector('.current_compare_at_price')?.textContent;

            // 设置原始价格
            if (priceElement) {
              priceElement.textContent = originalPrice;
              priceElement.setAttribute('data-original-price', originalPrice);
            }
            if (comparePriceElement && originalComparePrice) {
              comparePriceElement.textContent = originalComparePrice;
              comparePriceElement.setAttribute('data-original-price', originalComparePrice);
            }
          });

          const updateEventShow = new CustomEvent('updateEventShow', {
            detail: {
              price: productStickyFormPrice.querySelector('.price-container').getAttribute('data-current-price'),
              originalComparePrice: productStickyFormPrice
                .querySelector('.price-container')
                .getAttribute('data-compare-price'),
            },
          });
          console.log('productStickyFormPrice', productStickyFormPrice.querySelector('.price-container'));
          console.log('updateEventShow999', updateEventShow);
          window.dispatchEvent(updateEventShow);

          // 直接使用保存的数量触发更新
          const updateEvent = new CustomEvent('updateResult', {
            detail: currentQuantity,
          });
          window.dispatchEvent(updateEvent);

          if (chooseProducts) {
            this.skuSwatch();
            this.VariantFunction();
          }

          // 更新 DOM 后重新初始化 products-purchase 组件
          const productsPurchase2 = document.querySelector('products-purchase');
          if (productsPurchase2) {
            productsPurchase2.handleAddToCartClick();
            productsPurchase2.handleBuyNowClick();
          }
        }

        updateURL(currentUrl, currentId) {
          if (!currentUrl && !currentId) return;
          window.history.replaceState({}, '', `${currentUrl}?variant=${currentId}`);
        }
        // 处理进度条
        progressFuncion(res) {
          let maxStock = parseInt(res.getAttribute('data-max-stock'), 10); //最大库存数
          let currentStock = parseInt(res.getAttribute('data-stock'), 10); //当前变体的库存
          let percentage = (currentStock / maxStock) * 100;
          // 确保百分比不会超过 100%
          percentage = Math.min(percentage, 100);
          // 输出计算出的百分比
          // 可以将这个百分比用于设置进度条宽度
          let progressNum = res.querySelector('.progress-num');
          progressNum.style.width = percentage + '%';
        }
      }
    );
  }
});
